import { render, staticRenderFns } from "./NotificationsUpdates.vue?vue&type=template&id=78d34b1c&scoped=true&lang=pug"
import script from "./NotificationsUpdates.vue?vue&type=script&lang=ts"
export * from "./NotificationsUpdates.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsUpdates.vue?vue&type=style&index=0&id=78d34b1c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d34b1c",
  null
  
)

export default component.exports